(function () {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════════════
  // FAVORITEN v2 — Listenansicht.
  //
  // Ersetzt die Kartengalerie der alten Wishlist. Warum Zeilen statt Karten: die
  // Kunden fuehren Projekt- und Wiederbeschaffungslisten. Dafuer braucht es SKU,
  // Menge, Einzelpreis, Zeilensumme, Gesamtsumme und Mehrfachauswahl — eine
  // Galerie kann davon nichts.
  //
  // ⚠️ RENDERT OHNE PRODUKTABRUF. Titel, Bild und Kategorie stehen als
  // Schnappschuss in der Favoritenzeile. Die alte Fassung holte je Favorit eine
  // KOMPLETTE Produktseite (/products/x?view=card) plus ein zweites Mal
  // /products/x.js — bei 50 Favoriten rund 100 Anfragen.
  //
  // Nachgeladen wird nur zweierlei:
  //   Preise         1 Sammelanfrage, davor sofort aus window.B2BPriceCache (SWR)
  //   Verfuegbarkeit trage, je SICHTBAREM Produkt, dedupliziert
  // ═══════════════════════════════════════════════════════════════════════════

  var root = document.querySelector('[data-favorites-app]');
  if (!root) return;

  function cfg()      { return window.b2bConfig || {}; }
  function API_BASE() { return cfg().apiBase || 'https://pim.schaltschrank24.ch'; }
  function API_KEY()  { return cfg().apiKey || ''; }

  var F = null;

  // ⚠️ Dieses Modul laeuft VOR assets/favorites.js: die Sections binden es im BODY ein,
  // theme.liquid bindet favorites.js erst am Seitenende ein, und deferred Skripte laufen
  // in Dokumentreihenfolge. Frueher brach das Modul hier ab und die Seite blieb dauerhaft
  // auf „Wird geladen" stehen. Deshalb auf das Bereitschaftssignal warten.
  if (window.Favorites) {
    boot();
  } else {
    document.addEventListener('favorites:ready', boot, { once: true });
    // Sicherheitsnetz, falls favorites.js gar nicht geladen wird (Netzfehler, Blocker):
    // nach 8 s eine ehrliche Meldung statt eines ewigen Ladehinweises.
    setTimeout(function () {
      if (!F) {
        root.innerHTML = '';
        var p = document.createElement('p');
        p.className = 'fav-loading';
        p.textContent = (window.customStrings && window.customStrings.favFailed) || 'Das hat nicht geklappt.';
        root.appendChild(p);
      }
    }, 8000);
  }

  function boot() {
    F = window.Favorites;
    if (!F) return;
    // ⚠️ KEIN eigenes F.load(): favorites.js stoesst das Laden beim Start selbst an und
    // meldet favorites:ready unmittelbar danach — der Abruf ist also bereits unterwegs.
    // Ein zweiter Aufruf hier waere eine glatt verdoppelte Anfrage.
    document.addEventListener('favorites:changed', function () { render(); });
    render();
  }

  var view = { listId: null, mode: 'list', query: '' };   // mode: 'list' | 'category'
  var selected = {};                                       // itemId → true
  var prices = {};                                         // sku → Zahl | null
  var availability = {};                                   // handle → {available, label}
  var inFlight = {};                                       // itemId → true (ein Schreibvorgang je Zeile)
  var editTitleFor = null;                                 // listId, deren Titel gerade bearbeitet wird
  var titleDraft = null;                                   // halb getippter Name — ueberlebt render()

  /**
   * itemId → das Objekt, das GERADE gerendert ist.
   *
   * ⚠️⚠️ Unverzichtbar, seit „Alle" nach SKU zusammenfasst: dedupe() erzeugt KOPIEN.
   * Wer die Menge aendert, veraendert die Kopie — wer die Summe nachrechnet und dabei
   * ueber F.state.items geht, liest das ORIGINAL mit dem alten Wert. Ergebnis: gespeichert
   * wird richtig, angezeigt wird der alte Betrag. Beide Seiten muessen dasselbe Objekt
   * benutzen, und das ist dieses Register.
   */
  var rendered = {};

  // ── Hilfsmittel ────────────────────────────────────────────────────────────

  function T(k) { return F.T(k); }

  function money(chf) {
    // EINE Wahrheit fuer Betraege. window.SU.money kommt aus assets/unit-price.js;
    // der Ersatzpfad greift nur, wenn das Modul (noch) nicht geladen ist.
    if (window.SU && window.SU.money) return 'CHF ' + window.SU.money(chf, 2);
    var n = Math.round(Number((chf * 100).toPrecision(12))) / 100;
    var p = n.toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+$)/g, "'");
    return 'CHF ' + p.join('.');
  }

  /**
   * ⚠️ Zeilensumme = runde(Einzelpreis × Menge). NIEMALS den gerundeten
   * Stueckpreis mal Menge — bei Mengenrabatten laeuft das auseinander, und der
   * Server rechnet im DraftOrderBuilder ebenfalls auf der Position.
   */
  function lineTotal(unit, qty) {
    if (unit == null) return null;
    var raw = unit * qty;
    return window.SU ? window.SU.roundDec(raw, 2)
                     : Math.round(Number((raw * 100).toPrecision(12))) / 100;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;   // IMMER textContent — nie innerHTML
    return n;
  }

  function itemsOf(listId) {
    var all = F.state.items;
    var rows = listId == null ? dedupe(all) : all.filter(function (i) { return i.listId === listId; });
    if (view.query) {
      var q = view.query.toLowerCase();
      rows = rows.filter(function (i) {
        return (i.sku + ' ' + (i.title || '') + ' ' + (i.variantTitle || '')).toLowerCase().indexOf(q) !== -1;
      });
    }
    return rows;
  }

  /**
   * In der Ansicht „Alle" wird je SKU nur EINE Zeile gezeigt.
   *
   * Ein Artikel darf bewusst in mehreren Listen liegen (dasselbe Gehaeuse in zwei
   * Projekten). Ihn dort mehrfach aufzufuehren sieht wie ein Fehler aus und zaehlt
   * die Gesamtsumme doppelt. Stattdessen: eine Zeile, ein Hinweis auf die Listen,
   * und die Mengen aufaddiert — das ist die Zahl, die man in einer Gesamtschau will.
   *
   * ⚠️ Die Zusammenfassung ist eine reine ANSICHT. Gespeichert bleibt je Liste eine
   * eigene Position mit eigener Menge und eigener Notiz; bearbeitet wird darum in
   * der jeweiligen Liste, nicht hier.
   */
  function dedupe(items) {
    var bySku = {}, order = [];
    items.forEach(function (i) {
      if (!bySku[i.sku]) {
        // Flache Kopie: die Ansicht darf den Ursprungsdatensatz nicht veraendern.
        bySku[i.sku] = Object.assign({}, i, { _members: [i], _lists: [i.listId] });
        order.push(i.sku);
      } else {
        var g = bySku[i.sku];
        g._members.push(i);
        g._lists.push(i.listId);
        g.qty += i.qty;
        // Erste vorhandene Angabe gewinnt — so fuellt ein spaeter gemerkter Eintrag
        // Luecken eines frueheren (z. B. Kategorie aus der Alt-Uebernahme).
        ['title', 'variantTitle', 'imageUrl', 'category', 'note'].forEach(function (k) {
          if (!g[k] && i[k]) g[k] = i[k];
        });
      }
    });
    return order.map(function (sku) { return bySku[sku]; });
  }

  function listNamesOf(it) {
    return (it._lists || [it.listId]).map(function (id) {
      var l = F.state.lists.filter(function (x) { return x.id === id; })[0];
      return l ? l.name : '?';
    });
  }

  function currentList() {
    return F.state.lists.filter(function (l) { return l.id === view.listId; })[0] || null;
  }

  function canEdit() {
    var l = currentList();
    return view.listId == null ? true : !!(l && l.isOwn !== false);
  }

  // ── Preise ─────────────────────────────────────────────────────────────────

  function loadPrices(rows) {
    var skus = rows.map(function (r) { return r.sku; }).filter(Boolean);
    if (!skus.length) return;

    // Sofort aus dem Zwischenspeicher malen — kein „Flash of List Price".
    if (window.B2BPriceCache) {
      var cached = window.B2BPriceCache.getMany(skus);
      Object.keys(cached).forEach(function (s) { prices[s] = cached[s].price; });
      paintPrices();
    }

    var email = cfg().customerEmail || cfg().email;
    if (!email) return;                       // Gast: kein Kundenpreis, Listenpreis kommt lazy

    var url = API_BASE() + '/api/b2b/customer-prices?email=' + encodeURIComponent(email);
    skus.forEach(function (s) { url += '&skus[]=' + encodeURIComponent(s); });

    fetch(url, { headers: { 'X-Api-Key': API_KEY() } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var map = res.prices || res;
        // ⚠️ Eine leere Antwort NICHT als „Preis 0" deuten. Abacus drosselt
        // taeglich zwischen 12 und 14 Uhr und tarnt das als leeres Resultset —
        // dann lieber den zwischengespeicherten Preis stehen lassen.
        if (!map || !Object.keys(map).length) return;
        Object.keys(map).forEach(function (s) {
          var p = parseFloat(map[s]);
          prices[s] = isFinite(p) && p > 0 ? p : null;
        });
        if (window.B2BPriceCache && res.fallback_level) {
          window.B2BPriceCache.setMany(map, res.fallback_level);
        }
        paintPrices();
      })
      .catch(function () { /* Preise bleiben im Skelettzustand — Liste bleibt bedienbar */ });
  }

  // ── Verfuegbarkeit ─────────────────────────────────────────────────────────
  //
  // Traege und je PRODUKT (nicht je Variante) — mehrere Varianten desselben
  // Produkts teilen sich eine Anfrage.

  /**
   * ⚠️⚠️ FRUEHER wurden die Produktangaben nur fuer SICHTBARE Zeilen geladen
   * (IntersectionObserver). Ohne sie liefert priceOf() aber null — die Zeile hatte dann
   * keinen Preis, keine Positionssumme und fiel aus der GESAMTSUMME heraus. Auf einer
   * langen Liste stimmte die Summe deshalb nur fuer den Teil, den man gescrollt hatte,
   * und im Ausdruck standen unbepreiste Zeilen ueber einer zu kleinen Summe.
   *
   * Jetzt werden ALLE Produkte der aktuellen Ansicht geladen — aber gedrosselt, damit
   * eine Liste mit 200 Positionen nicht 200 gleichzeitige Abrufe ausloest. Je PRODUKT
   * ein Abruf, nicht je Variante.
   */
  var META_PARALLEL = 6;

  function ensureAllMeta(rows) {
    var handles = [];
    var seen = {};
    rows.forEach(function (r) {
      if (!r.handle || seen[r.handle] || availability[r.handle]) return;
      seen[r.handle] = true;
      handles.push(r.handle);
    });
    if (!handles.length) return Promise.resolve();

    var i = 0;
    function next() {
      if (i >= handles.length) return Promise.resolve();
      return fetchAvailability(handles[i++]).then(next);
    }
    var lanes = [];
    for (var k = 0; k < Math.min(META_PARALLEL, handles.length); k++) lanes.push(next());
    return Promise.all(lanes);
  }

  var availPending = {};

  /**
   * Ein Abruf je PRODUKT liefert alles Fehlende: Verfuegbarkeit, Verkaufseinheit,
   * Set-Kennzeichen, Gast-Packpreis und Kategorie.
   *
   * ⚠️ Ersetzt den frueheren /products/{handle}.js-Abruf. Der lieferte KEINE Metafelder —
   * ohne sales_unit_qty rechnet die Liste die Zeilensummen falsch (siehe
   * sections/section-fav-meta.liquid).
   */
  function fetchAvailability(handle) {
    if (!handle || availability[handle] || availPending[handle]) { paintAvailability(); return Promise.resolve(); }
    availPending[handle] = true;
    return fetch(window.localizeUrl('/products/' + encodeURIComponent(handle)) + '?view=favmeta')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (m) {
        if (!m || !m.v) { availability[handle] = { missing: true }; paintAvailability(); return; }
        availability[handle] = { bySku: m.v, title: m.title, cat: m.cat || null };
        paintAvailability();
        paintPrices();            // Normalisierung ist jetzt moeglich → Summen neu rechnen
        healSnapshots(handle);
      })
      .catch(function () { availability[handle] = { missing: true }; paintAvailability(); });
  }

  /**
   * Schnappschuss-Selbstheilung. Zieht veraltete Titel/Bilder nach — UND fuellt die
   * Kategorie bei Positionen, die ohne gespeichert wurden (die einmalige Uebernahme der
   * alten Merkliste kannte nur Produkt-Handles und konnte keine Metafelder mitbringen).
   */
  function healSnapshots(handle) {
    if (!F.loggedIn()) return;
    var a = availability[handle];
    if (!a || a.missing) return;
    F.state.items.forEach(function (it) {
      if (it.handle !== handle) return;
      var v = a.bySku[it.sku];
      if (!v) return;
      var patch = {};
      if (a.title && it.title !== a.title) patch.title = a.title;
      if (v.img && it.imageUrl !== v.img) patch.imageUrl = v.img;
      if (v.id && it.variantId !== v.id) patch.variantId = v.id;
      if (!it.category && a.cat) patch.category = a.cat;
      if (v.vt && it.variantTitle !== v.vt) patch.variantTitle = v.vt;
      if (!Object.keys(patch).length) return;
      F.api('PATCH', '/items/' + it.id, patch).then(function () {
        Object.assign(it, patch);
        render();
      }).catch(function () { /* Kosmetik — ein Fehlschlag darf nichts stoeren */ });
    });
  }

  /**
   * Preis EINER Position, so wie ihn der Warenkorb berechnet.
   *
   * ⚠️⚠️ Der Abacus-Wert ist je Artikel ENTWEDER der Packpreis ODER der Preis pro
   * Basiseinheit — welcher, steht nicht in der Antwort. window.SU.normalize entscheidet
   * das gegen den Gast-Packpreis, genau wie assets/b2b-prices.js es fuer den Warenkorb tut.
   * Ohne diesen Schritt zeigte die Liste bei Meterware den METERpreis als Positionspreis,
   * und die Gesamtsumme wich um den Faktor der Verkaufseinheit vom Warenkorb ab.
   *
   * @return {{pack:number, per:number|null, base:string|null}|null}
   */
  function priceOf(it) {
    var raw = prices[it.sku];
    if (raw == null) return null;

    var a = availability[it.handle];
    var v = a && a.bySku && a.bySku[it.sku];
    // Solange die Angaben fehlen, NICHT raten: lieber noch keinen Preis zeigen als einen
    // falschen. fetchAvailability holt sie fuer jede sichtbare Zeile nach.
    if (!v) return null;

    var q = parseFloat(v.suq || 0) || 0;
    var packGuest = (parseFloat(v.pack || 0) || 0) / 100;

    if (!window.SU) return { pack: raw, per: null, base: null };
    var n = window.SU.normalize(raw, packGuest, q, { isSet: !!v.set });
    return {
      pack: n.packPrice,
      per: q > 1 && !v.set ? n.perUnit : null,
      base: v.sub || null
    };
  }

  // ── Rendern ────────────────────────────────────────────────────────────────

  function render() {
    root.innerHTML = '';
    rendered = {};                    // veraltete Ansichtsobjekte nicht mitschleppen

    // ⚠️ Auswahl auf das beschraenken, was in dieser Ansicht ueberhaupt vorkommt. Sonst
    // bliebe nach einem Listenwechsel oder einer Suche eine unsichtbare Auswahl stehen —
    // die Summe waere kleiner als der Bestand, ohne dass man saehe, warum.
    if (Object.keys(selected).length) {
      var visible = {};
      itemsOf(view.listId).forEach(function (r) { visible[r.id] = true; });
      Object.keys(selected).forEach(function (id) { if (!visible[id]) delete selected[id]; });
    }
    root.appendChild(buildChips());

    if (!F.state.loaded) { root.appendChild(el('p', 'fav-loading', T('loading'))); return; }

    root.appendChild(buildToolbar());

    var rows = itemsOf(view.listId);
    if (!rows.length) { root.appendChild(buildEmpty()); return; }

    root.appendChild(view.mode === 'category' ? buildGrouped(rows) : buildTable(rows, null));
    root.appendChild(buildFooter(rows));

    paintPrices();
    paintAvailability();
    syncMasters();
    loadPrices(rows);
    // Ohne await: die Summen aktualisieren sich, sobald die Angaben eintreffen.
    ensureAllMeta(rows);
  }

  function buildChips() {
    var wrap = el('div', 'fav-chips');

    var own = F.state.lists.filter(function (l) { return l.isOwn !== false; });
    var shared = F.state.lists.filter(function (l) { return l.isOwn === false; });

    var all = el('button', 'fav-chip' + (view.listId == null ? ' is-active' : ''));
    all.type = 'button';
    all.appendChild(el('span', 'fav-chip__name', T('allLists')));
    all.appendChild(el('span', 'fav-chip__count', String(F.state.items.length)));
    all.addEventListener('click', function () { view.listId = null; selected = {}; render(); });
    wrap.appendChild(all);

    own.forEach(function (l) { wrap.appendChild(chip(l)); });

    if (F.loggedIn()) {
      var add = el('button', 'fav-chip fav-chip--add', '+ ' + T('newList'));
      add.type = 'button';
      add.addEventListener('click', function () { promptNewList(add); });
      wrap.appendChild(add);
    }

    if (shared.length) {
      var sep = el('div', 'fav-chips__shared');
      sep.appendChild(el('span', 'fav-chips__sharedlabel', T('sharedByColleagues')));
      shared.forEach(function (l) { sep.appendChild(chip(l, true)); });
      wrap.appendChild(sep);
    }
    return wrap;
  }

  function chip(l, isShared) {
    var b = el('button', 'fav-chip' + (view.listId === l.id ? ' is-active' : '') + (isShared ? ' fav-chip--shared' : ''));
    b.type = 'button';
    b.appendChild(el('span', 'fav-chip__name', l.name));      // frei eingegeben → nur Text
    if (isShared && l.ownerEmail) {
      b.appendChild(el('span', 'fav-chip__owner', l.ownerEmail));
    }
    b.appendChild(el('span', 'fav-chip__count', String(l.count || 0)));
    b.addEventListener('click', function () { view.listId = l.id; selected = {}; render(); });
    return b;
  }

  function promptNewList(anchor) {
    var form = el('form', 'fav-newlist');
    var input = el('input', 'fav-newlist__input');
    input.type = 'text'; input.maxLength = 120; input.placeholder = T('newListPlaceholder');
    var ok = el('button', 'fav-newlist__ok', '✓'); ok.type = 'submit';
    form.appendChild(input); form.appendChild(ok);
    anchor.replaceWith(form);
    input.focus();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = input.value.trim();
      if (!n) { render(); return; }
      ok.disabled = true;
      F.createList(n).then(function (id) { view.listId = id; render(); })
       .catch(function (err) { F.toast(err.message || T('failed')); render(); });
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') render(); });
  }

  function buildToolbar() {
    var bar = el('div', 'fav-toolbar');
    var l = currentList();

    if (l) {
      var own = l.isOwn !== false;
      bar.appendChild(own && F.loggedIn() ? titleEditor(l) : el('h2', 'fav-toolbar__title', l.name));
      if (own) bar.appendChild(listMenu(l));
      // Kollegenliste: lesbar, nicht beschreibbar — der Weg zum Mitarbeiten ist die Kopie.
      // Sieht aus wie „Liste einlesen" (gleiche Rolle: Hauptaktion der Leiste).
      else if (F.loggedIn()) bar.appendChild(duplicateButton(l, 'fav-toolbar__import fav-toolbar__copyown', T('copyAsOwn')));

      // Lageretiketten (Aufgabe #59): „Als Etiketten drucken". Per CSS versteckt, bis
      // konto-etiketten.js die Freigabe hat (html.etiketten-bereit) — auf /pages/wishlist
      // gibt es das Etiketten-Fenster nicht, dort bleibt der Knopf unsichtbar.
      // Auch Kollegenlisten: Lesen genuegt fuer ein Etikettenblatt (Server prueft assertMayRead).
      if (F.loggedIn()) {
        var etk = el('button', 'fav-toolbar__import fav-et-knopf', 'Als Etiketten drucken');
        etk.type = 'button';
        // Inline versteckt — die !important-Regel in main-konto.liquid blendet ihn ein.
        // Ohne diese Zeile stuende er auf /pages/wishlist sichtbar und wirkungslos da.
        etk.style.display = 'none';
        etk.addEventListener('click', function () {
          if (window.Etiketten) { window.Etiketten.oeffnen({ quelle: 'favoriten', liste: l.id }); }
        });
        bar.appendChild(etk);
      }
    }

    var search = el('input', 'fav-toolbar__search');
    search.type = 'search';
    search.placeholder = T('search');
    search.value = view.query;
    search.addEventListener('input', function () {
      view.query = search.value;
      var rows = itemsOf(view.listId);
      var body = root.querySelector('.fav-table, .fav-groups');
      if (body) body.replaceWith(view.mode === 'category' ? buildGrouped(rows) : buildTable(rows, null));
      var foot = root.querySelector('.fav-footer');
      if (foot) foot.replaceWith(buildFooter(rows));
      paintPrices(); paintAvailability(); syncMasters(); ensureAllMeta(rows);
    });
    bar.appendChild(search);

    var modes = el('div', 'fav-modes');
    [['list', T('viewList')], ['category', T('viewCategory')]].forEach(function (m) {
      var b = el('button', 'fav-mode' + (view.mode === m[0] ? ' is-active' : ''), m[1]);
      b.type = 'button';
      b.addEventListener('click', function () { view.mode = m[0]; render(); });
      modes.appendChild(b);
    });
    bar.appendChild(modes);

    // Schnellerfassung: Artikelliste aus Excel/CSV in DIESE Liste uebernehmen.
    // ⚠️ Nur mit Schreibrecht — eine firmenweit freigegebene Liste ist fuer Kollegen
    // lesbar, nicht beschreibbar.
    // ⚠️⚠️ NICHT nur auf window.BulkImport pruefen. Auf /pages/wishlist und /cart ist
    // bulk-import.js fest eingebunden, im Konto NICHT — dort kommt es ueber den
    // Nachlader aus snippets/cart-drawer.liquid (window.BulkImportLoad), und der laedt
    // erst beim Klick. Die alte Bedingung war zum Renderzeitpunkt schlicht falsch, und
    // der Knopf fehlte im Konto komplett.
    if (canEdit() && (window.BulkImport || window.BulkImportLoad)) {
      // ⚠️ NICHT ueber T(): das ist der Favoriten-Uebersetzer und sucht `favXxx`.
      // Die Schnellerfassung liegt unter `biXxx` — sonst stuende hier woertlich
      // der Schluesselname auf dem Knopf.
      var cs = window.customStrings || {};
      var imp = el('button', 'fav-toolbar__import', cs.biOpenList || 'Liste einlesen');
      imp.type = 'button';
      imp.addEventListener('click', function () {
        // Erst beim Klick aufloesen — bis dahin kann das Modul laengst da sein.
        // ⚠️ open() nicht aus dem Objekt herausloesen, sonst geht `this` verloren.
        var opts = { target: 'list', listId: view.listId };
        if (window.BulkImport) window.BulkImport.open(opts);
        else if (window.BulkImportLoad) window.BulkImportLoad(opts);
      });
      bar.appendChild(imp);
    }

    // ⚠️ NUR in der Kategorie-Sicht. In der Listensicht waehlt das Kopfkaestchen der
    // Tabelle bereits alles aus — dort waere eine zweite Alles-Auswahl doppelt gemoppelt.
    // ⚠️ Und nur, wenn ueberhaupt etwas dasteht: „Alle auswaehlen (0)" ueber einem leeren
    // Bereich ist ein Angebot, das ins Leere greift.
    if (canEdit() && view.mode === 'category' && itemsOf(view.listId).length) {
      bar.appendChild(buildSelectBar());
    }
    return bar;
  }

  function listMenu(l) {
    var wrap = el('div', 'fav-listmenu');

    // Ohne Anmeldung gibt es nur die Gastliste im Browser — dort laeuft nichts ueber den
    // Server, also weder Umbenennen noch Duplizieren.
    if (F.loggedIn()) {
      var ren = el('button', 'fav-listmenu__btn', T('rename'));
      ren.type = 'button';
      ren.addEventListener('click', function () { editTitleFor = l.id; titleDraft = null; render(); });
      wrap.appendChild(ren);

      wrap.appendChild(duplicateButton(l, 'fav-listmenu__btn', T('duplicate')));
    }

    if (F.state.canShare) {
      var isShared = l.visibility === 'company';
      var sh = el('button', 'fav-listmenu__btn', isShared ? T('unshare') : T('share'));
      sh.type = 'button';
      sh.addEventListener('click', function () {
        F.api('PATCH', '/lists/' + l.id, { visibility: isShared ? 'private' : 'company' })
          .then(F.load).then(render)
          .catch(function (e) { F.toast(e.message || T('failed')); });
      });
      wrap.appendChild(sh);
    }

    var del = el('button', 'fav-listmenu__btn fav-listmenu__btn--danger', T('deleteList'));
    del.type = 'button';
    del.addEventListener('click', function () {
      var others = F.state.lists.filter(function (x) { return x.isOwn !== false && x.id !== l.id; });
      // „Inhalt behalten" nur anbieten, wenn es ein Ziel gibt — sonst waere es
      // ein Versprechen, das der Server nicht halten kann.
      var keep = false;
      if (others.length && (l.count || 0) > 0) {
        keep = window.confirm(T('deleteKeepItems'));
      } else if ((l.count || 0) > 0) {
        if (!window.confirm(T('deleteWithItems'))) return;
      } else if (!window.confirm(T('deleteConfirm'))) return;

      F.api('DELETE', '/lists/' + l.id + (keep ? '?keepItems=1' : ''))
        .then(F.load).then(function () { view.listId = null; render(); })
        .catch(function (e) { F.toast(e.message || T('failed')); });
    });
    wrap.appendChild(del);
    return wrap;
  }

  // ── Duplizieren und Umbenennen ─────────────────────────────────────────────

  /**
   * Ganze Liste als neue, eigene Liste kopieren — fuer eigene Listen („Duplizieren") und
   * fuer freigegebene Kollegenlisten („Als eigene Liste kopieren").
   *
   * Danach steht man IN der Kopie, und der Titel ist schon als Eingabefeld mit markiertem
   * Namen offen: wer kopiert, will fast immer gleich umbenennen. Esc behaelt den Vorschlag.
   *
   * ⚠️ Den Namen baut der SERVER (Kuerzen auf 120 Zeichen, „(Kopie 2)" …). Von hier geht nur
   * der uebersetzte Zusatz mit.
   * ⚠️ Gesperrt, solange die Anfrage laeuft — ein Doppelklick ergaebe sonst zwei Kopien.
   */
  function duplicateButton(l, cls, label) {
    var b = el('button', cls, label);
    b.type = 'button';

    var max = (F.state.limits || {}).maxLists || 0;
    if (max && F.ownLists().length >= max) {
      // Vorher sagen statt hinterher scheitern.
      b.disabled = true;
      b.title = T('listLimitReached').replace('{n}', String(max));
    }

    b.addEventListener('click', function () {
      if (b.disabled) return;
      b.disabled = true;
      F.api('POST', '/lists/' + l.id + '/duplicate', { suffix: T('copySuffix') })
        .then(function (j) {
          view.listId = j.id;
          selected = {};
          editTitleFor = j.id;
          titleDraft = null;
          return F.load().then(function () {
            render();
            F.toastUndo(T('duplicated').replace('{n}', String(j.count || 0)), function () {
              undoDuplicate(j.id, l.id);
            });
          });
        })
        .catch(function (e) { b.disabled = false; F.toast(e.message || T('failed')); });
    });
    return b;
  }

  /** Rueckgaengig nach dem Duplizieren: Kopie loeschen und zurueck zur Quelle. */
  function undoDuplicate(copyId, sourceId) {
    if (editTitleFor === copyId) { editTitleFor = null; titleDraft = null; }
    F.api('DELETE', '/lists/' + copyId)
      .then(F.load)
      .then(function () {
        var back = F.state.lists.some(function (x) { return x.id === sourceId; });
        view.listId = back ? sourceId : null;
        selected = {};
        render();
      })
      .catch(function (e) { F.toast(e.message || T('failed')); });
  }

  /** Listentitel, der sich per Klick (oder Enter/Leertaste) in ein Eingabefeld verwandelt. */
  function titleEditor(l) {
    if (editTitleFor === l.id) return titleInput(l);

    var h = el('h2', 'fav-toolbar__title fav-toolbar__title--editable', l.name);
    h.tabIndex = 0;
    h.setAttribute('role', 'button');
    h.title = T('renameHint');
    function start() { editTitleFor = l.id; titleDraft = null; render(); }
    h.addEventListener('click', start);
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); start(); }
    });
    return h;
  }

  /**
   * Eingabefeld fuer den Listentitel.
   *
   * Enter und Verlassen des Feldes speichern — auf dem Handy ist Verlassen der erwartete
   * Weg. Esc verwirft. Leer oder unveraendert schliesst ohne Anfrage.
   *
   * ⚠️⚠️ Der Zustand liegt in editTitleFor/titleDraft, NICHT nur im Feld: F.load() loest
   * ueber `favorites:changed` ein komplettes render() aus. Ohne den Entwurf ginge ein halb
   * getippter Name bei jedem Neuaufbau verloren.
   * ⚠️ Bei einem Fehler (z. B. 409 „Name gibt es schon") bleibt das Feld offen, die Meldung
   * steht direkt daneben — ein Toast am Bildschirmrand waere zu weit weg vom Fehler.
   */
  function titleInput(l) {
    var wrap = el('div', 'fav-titleedit');
    var input = el('input', 'fav-titleedit__input');
    input.type = 'text';
    input.maxLength = 120;
    input.value = titleDraft != null ? titleDraft : l.name;
    input.setAttribute('aria-label', T('rename'));
    var msg = el('span', 'fav-titleedit__msg');
    msg.setAttribute('role', 'alert');
    wrap.appendChild(input);
    wrap.appendChild(msg);

    var fresh = titleDraft == null;
    var busy = false, done = false;

    function close() {
      done = true;
      editTitleFor = null;
      titleDraft = null;
      render();
    }

    function save() {
      if (busy || done) return;
      var n = input.value.replace(/\s+/g, ' ').trim();
      if (!n || n === l.name) { close(); return; }

      busy = true;
      // readOnly statt disabled: disabled nimmt den Fokus weg und loest erneut blur aus.
      input.readOnly = true;
      msg.textContent = '';
      F.api('PATCH', '/lists/' + l.id, { name: n })
        .then(function () {
          done = true;
          editTitleFor = null;
          titleDraft = null;
          return F.load();
        })
        .then(render)
        .catch(function (e) {
          busy = false;
          input.readOnly = false;
          msg.textContent = e.message || T('failed');
          input.focus();
        });
    }

    input.addEventListener('input', function () { titleDraft = input.value; msg.textContent = ''; });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); save(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); }
    });
    // ⚠️ Nur ein ECHTES Verlassen speichert. Manche Browser feuern blur auch, wenn render()
    // das Feld aus dem DOM nimmt — dann wuerde ein halber Entwurf ungefragt gespeichert.
    input.addEventListener('blur', function () { if (input.isConnected) save(); });

    // Erst nach dem Einhaengen fokussieren. Beim ersten Oeffnen alles markieren, damit man
    // einfach lostippt; nach einem Neuaufbau den Cursor ans Ende statt den Entwurf zu markieren.
    requestAnimationFrame(function () {
      if (!input.isConnected) return;
      input.focus();
      if (fresh) input.select();
      else input.setSelectionRange(input.value.length, input.value.length);
    });
    return wrap;
  }

  /**
   * „Alle auswaehlen" — eigene Zeile DIREKT UEBER der Tabelle.
   *
   * ⚠️⚠️ Wird NUR in der Kategorie-Sicht gerendert. In der Listensicht gibt es genau eine
   * Tabelle, deren Kopfkaestchen ohnehin alles auswaehlt — dort ist diese Zeile ueberfluessig.
   * Gebraucht wird sie erst, wenn die Tabelle in Gruppen zerfaellt: dann ist jedes
   * Kopfkaestchen nur fuer SEINE Gruppe zustaendig und eine Alles-Auswahl fehlt sonst ganz.
   *
   * Platz: eigene zweite Reihe der Werkzeugleiste, direkt unter dem Suchfeld
   * (`.fav-selectbar { flex: 0 0 100% }` erzwingt den Umbruch). Sie steht damit ueber
   * ALLEN Gruppen und ist raeumlich klar vom Kopfkaestchen einer einzelnen Gruppe getrennt.
   *
   * Kaestchen UND Schriftzug in EINEM <label>: ein Klick auf den Text schaltet das
   * Kaestchen mit, das macht <label> von selbst. Den Zustand traegt das Kaestchen —
   * an / aus / halb, gesetzt ausschliesslich in syncMasters().
   */
  function buildSelectBar() {
    var wrap = el('div', 'fav-selectbar');
    var lab = el('label', 'fav-selectall');
    var box = document.createElement('input');
    box.type = 'checkbox';
    box.className = 'fav-selectall__box';
    box.setAttribute('data-select-all-box', '1');
    box.addEventListener('change', function () {
      setSelection(itemsOf(view.listId), box.checked);
    });
    var txt = el('span', 'fav-selectall__text');
    txt.setAttribute('data-select-all', '1');
    lab.appendChild(box);
    lab.appendChild(txt);
    wrap.appendChild(lab);
    return wrap;
  }

  function buildGrouped(rows) {
    var wrap = el('div', 'fav-groups');
    var groups = {};
    rows.forEach(function (r) {
      var k = r.category || '￿';        // ohne Kategorie ans Ende sortieren
      (groups[k] = groups[k] || []).push(r);
    });
    Object.keys(groups).sort().forEach(function (k) {
      var det = el('details', 'fav-group');
      det.open = true;
      var sum = el('summary', 'fav-group__head');
      sum.appendChild(el('span', 'fav-group__name', k === '￿' ? T('noCategory') : k));
      sum.appendChild(el('span', 'fav-group__count', String(groups[k].length)));
      var sub = el('span', 'fav-group__sum');
      sub.dataset.groupSum = k;
      sum.appendChild(sub);
      det.appendChild(sum);
      det.appendChild(buildTable(groups[k], k, k === '\uffff' ? T('noCategory') : k));
      wrap.appendChild(det);
    });
    return wrap;
  }

  function buildTable(rows, groupKey, groupLabel) {
    var table = el('table', 'fav-table');
    if (groupKey != null) table.dataset.group = groupKey;

    var thead = el('thead');
    var tr = el('tr');

    if (canEdit()) {
      var thSel = el('th', 'fav-row__select');
      var master = document.createElement('input');
      master.type = 'checkbox';
      master.dataset.master = rows.map(function (r) { return r.id; }).join(',');
      // ⚠️⚠️ In der Kategorie-Sicht darf hier NICHT „Alle auswaehlen" stehen. Das
      // Kaestchen waehlt genau EINE Gruppe, und das oberste davon sitzt exakt dort,
      // wo man die globale Auswahl vermutet — der Titel hat die Bedienung in die
      // Irre gefuehrt („waehlt nur die erste Kategorie aus"). Global ist allein der
      // Knopf „Alle auswaehlen (n)" in der Werkzeugleiste.
      var mlabel = T('selectAll');
      if (groupLabel != null) {
        var tpl = T('selectGroup');
        // Fehlt der Schluessel, gibt T() den Schluesselnamen zurueck. Dann lieber nur
        // den Kategorienamen zeigen als ein falsches Versprechen.
        if (tpl.indexOf('{name}') === -1) tpl = '{name}';
        mlabel = tpl.replace('{name}', groupLabel);
      }
      master.setAttribute('aria-label', mlabel);
      master.title = mlabel;
      master.addEventListener('change', function () { setSelection(rows, master.checked); });
      thSel.appendChild(master);
      tr.appendChild(thSel);
    }

    // ⚠️ Jede Kopfzelle braucht die Klasse IHRER Spalte. Ohne sie blieben im Druck die
    // Kopfzellen von Bild, Verfuegbarkeit und Aktionen stehen, waehrend die zugehoerigen
    // Datenzellen ausgeblendet sind — die Kopfzeile verschiebt sich dann um drei Spalten
    // und „Menge" und „Summe" fallen rechts heraus.
    [['fav-col-img', ''], ['fav-col-main', T('colArticle')], ['fav-col-avail', T('colAvail')],
     ['fav-col-price', T('colPrice')], ['fav-col-qty', T('colQty')],
     ['fav-col-total', T('colTotal')], ['fav-col-actions', '']]
      .forEach(function (c) { tr.appendChild(el('th', c[0], c[1])); });
    thead.appendChild(tr);
    table.appendChild(thead);

    var tbody = el('tbody');
    rows.forEach(function (r) { tbody.appendChild(buildRow(r)); });
    table.appendChild(tbody);
    return table;
  }

  function buildRow(it) {
    rendered[it.id] = it;
    var multi = (it._lists || []).length > 1;
    var tr = el('tr', 'fav-row' + (multi ? ' fav-row--multi' : ''));
    tr.dataset.itemId = String(it.id);
    tr.dataset.sku = it.sku;

    if (canEdit()) {
      var tdSel = el('td', 'fav-row__select');
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = !!selected[it.id];
      cb.addEventListener('change', function () {
        if (cb.checked) selected[it.id] = true; else delete selected[it.id];
        syncMasters();            // Kopfkaestchen ggf. auf „halb" stellen
        refreshFooter();          // baut die Fusszeile neu und ruft paintTotals()
      });
      tdSel.appendChild(cb);
      tr.appendChild(tdSel);
    }

    var tdImg = el('td', 'fav-row__img');
    if (it.imageUrl) {
      var img = document.createElement('img');
      img.src = it.imageUrl; img.alt = ''; img.loading = 'lazy';
      img.width = 56; img.height = 56;
      tdImg.appendChild(img);
    }
    tr.appendChild(tdImg);

    var tdMain = el('td', 'fav-row__main');
    var a = document.createElement('a');
    a.className = 'fav-row__title';
    a.href = window.localizeUrl('/products/' + it.handle) + (it.variantId ? '?variant=' + it.variantId : '');
    a.textContent = it.title || it.sku;
    tdMain.appendChild(a);
    var meta = el('div', 'fav-row__meta');
    meta.appendChild(el('span', 'fav-row__sku', it.sku));
    if (it.variantTitle) meta.appendChild(el('span', 'fav-row__variant', it.variantTitle));
    if (it.category) meta.appendChild(el('span', 'fav-row__cat', it.category));
    if (multi) {
      // Kennzeichen statt Doppelzeile: der Kunde sieht sofort, dass der Artikel in
      // mehreren Listen liegt — und in welchen.
      var names = listNamesOf(it);
      var badge = el('span', 'fav-row__lists', T('inLists').replace('{n}', String(names.length)));
      badge.title = names.join(' · ');
      meta.appendChild(badge);
    }
    tdMain.appendChild(meta);
    tdMain.appendChild(noteArea(it));
    tr.appendChild(tdMain);

    var tdAvail = el('td', 'fav-row__avail');
    tdAvail.dataset.availSlot = '1';
    tdAvail.dataset.handle = it.handle;
    tdAvail.appendChild(el('span', 'fav-skel', ''));
    tr.appendChild(tdAvail);

    var tdPrice = el('td', 'fav-row__price');
    tdPrice.dataset.priceSlot = it.sku;
    tdPrice.appendChild(el('span', 'fav-skel', ''));
    tr.appendChild(tdPrice);

    var tdQty = el('td', 'fav-row__qty');
    var qtyInfo = el('div', 'fav-qty-info');
    qtyInfo.dataset.qtyInfo = String(it.id);
    var qty = document.createElement('input');
    qty.type = 'number'; qty.min = '0.001'; qty.step = 'any';
    qty.value = String(it.qty);
    qty.className = 'fav-qty';
    // ⚠️ In der Zusammenfassung ist die Menge eine SUMME ueber mehrere Listen — sie
    // liesse sich nicht eindeutig zurueckschreiben. Bearbeitet wird in der Liste selbst.
    qty.disabled = !canEdit() || multi;
    if (multi) qty.title = T('qtyInListsHint');
    qty.addEventListener('input', function () { if (!multi) debounceQty(it, qty); });
    tdQty.appendChild(qty);
    tdQty.appendChild(qtyInfo);
    tr.appendChild(tdQty);

    var tdTotal = el('td', 'fav-row__total');
    tdTotal.dataset.totalSlot = String(it.id);
    tr.appendChild(tdTotal);

    var tdAct = el('td', 'fav-row__actions');

    // Warenkorb je Zeile: der haeufigste Fall ist „diesen einen Artikel jetzt bestellen".
    // Dafuer erst ankreuzen und dann in die Fusszeile greifen zu muessen, waeren zwei
    // Schritte zu viel. Gilt auch auf fremden (firmenweit freigegebenen) Listen — bestellen
    // darf man daraus, nur aendern nicht.
    var cart = el('button', 'fav-row__cart');
    cart.type = 'button';
    cart.title = T('addThisToCart');
    cart.setAttribute('aria-label', T('addThisToCart'));
    cart.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"'
      + ' stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
      + '<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/>'
      + '<path d="M2 3h3l2.2 11.2a1.5 1.5 0 0 0 1.5 1.2h8.4a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></svg>';
    cart.addEventListener('click', function () { addRowsToCart([it], cart); });
    tdAct.appendChild(cart);

    if (canEdit()) {
      var rm = el('button', 'fav-row__remove', '×');
      rm.type = 'button';
      rm.setAttribute('aria-label', T('remove'));
      if (multi) rm.title = T('removeFromAll');
      rm.addEventListener('click', function () {
        if (multi && !window.confirm(T('removeFromAllConfirm').replace('{lists}', listNamesOf(it).join(', ')))) return;
        removeRow(it, tr);
      });
      tdAct.appendChild(rm);
    } else {
      var cp = el('button', 'fav-row__copy', T('copy'));
      cp.type = 'button';
      cp.addEventListener('click', function () { copyToOwn([it.id]); });
      tdAct.appendChild(cp);
    }
    tr.appendChild(tdAct);

    return tr;
  }

  // ── Alles auswaehlen ───────────────────────────────────────────────────────
  //
  // Zwei Ebenen, weil die Ansicht zwei Ebenen hat:
  //   Kopfzeile der Tabelle → genau diese Tabelle (in der Kategorie-Sicht also EINE Gruppe)
  //   Werkzeugleiste        → alles, was gerade sichtbar ist (auch ueber Gruppen hinweg)
  //
  // ⚠️ „Sichtbar" heisst: nach Liste UND Suchfilter. Wer nach „Kanal" sucht und dann alles
  // auswaehlt, erwartet die Treffer — nicht den ganzen Bestand.

  function setSelection(rows, on) {
    rows.forEach(function (r) {
      if (on) selected[r.id] = true; else delete selected[r.id];
      var cb = root.querySelector('.fav-row[data-item-id="' + r.id + '"] .fav-row__select input');
      if (cb) { cb.checked = !!on; cb.indeterminate = false; }
    });
    syncMasters();
    refreshFooter();
  }

  /** Kopfkaestchen an den tatsaechlichen Zustand angleichen (an, aus, halb). */
  function syncMasters() {
    root.querySelectorAll('[data-master]').forEach(function (cb) {
      var ids = (cb.dataset.master || '').split(',').filter(Boolean).map(Number);
      if (!ids.length) return;
      var n = ids.filter(function (id) { return selected[id]; }).length;
      cb.checked = n === ids.length;
      cb.indeterminate = n > 0 && n < ids.length;
    });
    var all = itemsOf(view.listId);
    var link = root.querySelector('[data-select-all]');
    if (link) {
      var picked = all.filter(function (r) { return selected[r.id]; }).length;
      var full = all.length > 0 && picked === all.length;
      link.textContent = full ? T('clearSelection') : T('selectAll') + ' (' + all.length + ')';
      link.dataset.on = full ? '1' : '';
      // ⚠️ Das Kaestchen wird HIER gesetzt, nie im change-Handler: setSelection ruft
      // syncMasters ohnehin auf, und die Auswahl aendert sich auch ueber Zeilen- und
      // Gruppenkaestchen. „Halb" ist der haeufigste Zustand und darf nicht fehlen.
      var box = root.querySelector('[data-select-all-box]');
      if (box) {
        box.checked = full;
        box.indeterminate = picked > 0 && !full;
      }
    }
  }

  // ── Notizen ────────────────────────────────────────────────────────────────
  //
  // Die Notiz ist der Grund, warum aus einer Merkliste eine Projektliste wird:
  // „für Halle 2", „Ersatz für defekten Kanal", „Angebot 4711 abwarten".
  // Deshalb direkt in der Zeile bearbeitbar und nicht in einem Dialog versteckt.
  //
  // ⚠️ Anzeige IMMER per textContent — die Notiz ist freier Kundentext.

  function noteArea(it) {
    var wrap = el('div', 'fav-row__notewrap');
    render();
    return wrap;

    function render() {
      wrap.innerHTML = '';
      if (!canEdit() || (it._lists || []).length > 1) {
        // Fremde Liste, oder Zusammenfassung ueber mehrere Listen: Notiz lesen ja,
        // aendern nein — sie gehoert zu genau einer Position in genau einer Liste.
        if (it.note) {
          var ro = el('div', 'fav-row__note fav-row__note--readonly', it.note);
          ro.title = T('noteEditInList');
          wrap.appendChild(ro);
        }
        return;
      }
      var btn = el('button', it.note ? 'fav-row__note' : 'fav-row__noteadd');
      btn.type = 'button';
      btn.title = T('editNote');
      if (it.note) {
        // ⚠️ Der Text allein sieht nach dem Speichern wie statischer Inhalt aus. Ein
        // Stift-Zeichen macht sichtbar, dass die Notiz jederzeit wieder aufgeht.
        btn.appendChild(el('span', 'fav-row__notetext', it.note));
        var pen = el('span', 'fav-row__noteedit');
        pen.setAttribute('aria-hidden', 'true');
        pen.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor"'
          + ' stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false">'
          + '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
        btn.appendChild(pen);
      } else {
        btn.appendChild(el('span', null, '+ ' + T('addNote')));
      }
      btn.addEventListener('click', edit);
      wrap.appendChild(btn);
    }

    function edit() {
      wrap.innerHTML = '';
      var ta = document.createElement('textarea');
      ta.className = 'fav-note-input';
      ta.rows = 2;
      ta.maxLength = 500;                 // deckungsgleich mit VARCHAR(500) im Server
      ta.placeholder = T('notePlaceholder');
      ta.value = it.note || '';
      wrap.appendChild(ta);

      var bar = el('div', 'fav-note-actions');
      var ok = el('button', 'fav-note-save', T('saveNote'));
      ok.type = 'button';
      var cancel = el('button', 'fav-note-cancel', T('cancel'));
      cancel.type = 'button';
      bar.appendChild(ok); bar.appendChild(cancel);
      wrap.appendChild(bar);

      ta.focus();
      ta.setSelectionRange(ta.value.length, ta.value.length);

      // Enter speichert, Shift+Enter macht einen Zeilenumbruch, Escape verwirft.
      ta.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); render(); }
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); save(); }
      });
      ok.addEventListener('click', save);
      cancel.addEventListener('click', render);

      function save() {
        var v = ta.value.trim();
        if (v === (it.note || '')) { render(); return; }
        ok.disabled = true;
        var previous = it.note;
        it.note = v || null;               // optimistisch
        F.api('PATCH', '/items/' + it.id, { note: v })
          .then(render)
          .catch(function (e) {
            it.note = previous;            // Rollback auf den bestaetigten Stand
            render();
            F.toast(e.status === 401 ? T('sessionExpired') : (e.message || T('failed')));
          });
      }
    }
  }

  // ── Schreiben aus der Liste ────────────────────────────────────────────────

  var qtyTimers = {};

  function debounceQty(it, input) {
    clearTimeout(qtyTimers[it.id]);
    qtyTimers[it.id] = setTimeout(function () {
      var v = parseFloat(input.value);
      if (!isFinite(v) || v <= 0) return;
      var previous = it.qty;
      it.qty = v;                       // optimistisch (Ansichtsobjekt)
      // ⚠️ Auch den Zustand nachziehen, sonst zeigt das naechste Neuzeichnen wieder den
      // alten Wert. Bei zusammengefassten Zeilen gibt es genau EIN Mitglied — sonst waere
      // das Feld gesperrt, weil sich eine Summe nicht eindeutig aufteilen laesst.
      var members = it._members || [it];
      if (members.length === 1) {
        var src = F.state.items.filter(function (x) { return x.id === members[0].id; })[0];
        if (src) src.qty = v;
      }
      paintQtyInfo();          // Gesamtmenge folgt der neuen Stueckzahl
      paintTotals();
      if (!F.loggedIn()) return;
      if (inFlight[it.id]) return;      // ein Schreibvorgang je Zeile
      inFlight[it.id] = true;
      F.api('PATCH', '/items/' + it.id, { qty: v })
        .catch(function (e) {
          it.qty = previous;            // Rollback auf den bestaetigten Wert
          var m = it._members || [it];
          if (m.length === 1) {
            var back = F.state.items.filter(function (x) { return x.id === m[0].id; })[0];
            if (back) back.qty = previous;
          }
          input.value = String(previous);
          paintTotals();
          F.toast(e.status === 401 ? T('sessionExpired') : (e.message || T('failed')));
        })
        .then(function () { delete inFlight[it.id]; });
    }, 600);
  }

  function removeRow(it, tr) {
    tr.classList.add('is-removing');
    // In der Zusammenfassung steht eine Zeile fuer mehrere Positionen — alle entfernen.
    var ids = (it._members || [it]).map(function (m) { return m.id; });
    Promise.all(ids.map(function (id) { return F.api('DELETE', '/items/' + id); }))
      .then(F.load)
      .then(function () { render(); })
      .catch(function (e) {
        tr.classList.remove('is-removing');
        F.toast(e.message || T('failed'));
      });
  }

  function copyToOwn(ids) {
    var target = F.defaultList();
    if (!target) return;
    F.api('POST', '/copy', { itemIds: ids, targetListId: target.id })
      .then(F.load)
      .then(function () { F.toast(T('copied') + ' ' + target.name); render(); })
      .catch(function (e) { F.toast(e.message || T('failed')); });
  }

  // ── Drucken ────────────────────────────────────────────────────────────────
  //
  // Kein Server-PDF: der vorhandene Chromium-Renderer (PriceListPdfRenderer) ist unter
  // PHP-FPM nicht erreichbar. Der Browserdruck zeigt ausserdem immer die AKTUELLEN
  // Kundenpreise und kostet keinen Serverlauf.
  //
  // ⚠️ Der Druckkopf steht als Liquid im Dokument (snippets/favorites-print-header.liquid),
  // weil CSS kein Logo einsetzen kann. Hier werden nur die veraenderlichen Felder gefuellt —
  // und zwar UNMITTELBAR vor dem Druck, damit Datum und Anzahl stimmen.

  function preparePrint(rows) {
    var chosen = Object.keys(selected).length
      ? rows.filter(function (r) { return selected[r.id]; })
      : rows;

    function put(sel, text) {
      document.querySelectorAll(sel).forEach(function (n) { n.textContent = text; });
    }

    var list = currentList();
    var name = list ? list.name : T('allLists');
    if (Object.keys(selected).length) name += ' — ' + T('totalSelected').replace('{n}', String(chosen.length));
    put('[data-print-list]', name);

    // ⚠️ Datum und Anzahl ERST JETZT setzen, nicht beim Seitenaufbau: auf einer lange
    // offenen Seite stuende sonst ein falsches Datum auf dem Ausdruck.
    var d = new Date();
    put('[data-print-date]', d.toLocaleDateString(document.documentElement.lang || 'de-CH',
        { day: '2-digit', month: '2-digit', year: 'numeric' }));
    put('[data-print-count]', String(chosen.length));

    var ses = null;
    try { ses = JSON.parse(localStorage.getItem('b2b_session') || 'null'); } catch (e) {}
    var who = ses && ((ses.company && ses.company.name) ||
                      [ses.firstName, ses.lastName].filter(Boolean).join(' ')) || '';
    put('[data-print-customer]', who || '–');

    buildPrintRoot();
  }

  /**
   * ⚠️ Vor dem Drucken MUSS jede Position bepreist sein. Sonst stehen unbepreiste Zeilen
   * ueber einer Summe, die sie nicht enthaelt — genau der Fehler, den das gedrosselte
   * Vollladen behebt. Beim Knopfdruck warten wir deshalb ab.
   */
  function printWhenReady(rows, btn) {
    var chosen = Object.keys(selected).length
      ? rows.filter(function (r) { return selected[r.id]; })
      : rows;
    var missing = chosen.filter(function (r) { return !availability[r.handle]; });
    if (!missing.length) { preparePrint(rows); window.print(); setTimeout(removePrintRoot, 1500); return; }

    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = T('loading');
    ensureAllMeta(chosen).then(function () {
      paintPrices();
      btn.disabled = false; btn.textContent = label;
      preparePrint(rows);
      window.print();
      setTimeout(removePrintRoot, 1500);
    }).catch(function () {
      btn.disabled = false; btn.textContent = label;
      preparePrint(rows); window.print(); setTimeout(removePrintRoot, 1500);
    });
  }

  /**
   * Nur die Liste drucken — ohne Kopfzeile, Navigation, Fussbereich und Warenkorb des Shops.
   *
   * ⚠️ Einzelne Theme-Bereiche per CSS auszublenden waere ein Katz-und-Maus-Spiel: jede neue
   * Section im Shop kaeme ungefragt auf den Ausdruck. Stattdessen wird eine KOPIE der Liste
   * als direktes Kind von <body> abgelegt und alles daneben ausgeblendet — was der Shop
   * sonst noch mitbringt, spielt damit keine Rolle mehr.
   *
   * ⚠️ Bewusst eine Kopie, kein Verschieben: der laufenden Seite darf beim Drucken nichts
   * unter den Fuessen weggezogen werden.
   */
  function buildPrintRoot() {
    removePrintRoot();
    var app = root;
    var wrap = document.createElement('div');
    wrap.id = 'fav-print-root';

    ['.fav-print-head', '.fav-print-titleblock'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (n) wrap.appendChild(n.cloneNode(true));
    });
    wrap.appendChild(app.cloneNode(true));
    ['.fav-print-legal', '.fav-print-foot'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (n) wrap.appendChild(n.cloneNode(true));
    });

    document.body.appendChild(wrap);
    document.body.classList.add('fav-printing');
  }

  function removePrintRoot() {
    var old = document.getElementById('fav-print-root');
    if (old) old.remove();
    document.body.classList.remove('fav-printing');
  }

  // Auch bei Strg+P greifen, nicht nur beim Knopf.
  window.addEventListener('beforeprint', function () {
    if (!document.getElementById('fav-print-root')) preparePrint(itemsOf(view.listId));
  });
  window.addEventListener('afterprint', removePrintRoot);

  // ── Fusszeile ──────────────────────────────────────────────────────────────

  function buildFooter(rows) {
    var f = el('div', 'fav-footer');

    var selCount = Object.keys(selected).length;
    if (selCount) {
      f.appendChild(el('span', 'fav-footer__sel', selCount + ' ' + T('selected')));
      if (F.loggedIn()) {
        var assign = el('button', 'fav-footer__btn', T('addToLists') + ' ▾');
        assign.type = 'button';
        assign.addEventListener('click', function (e) { e.stopPropagation(); openAssign(assign, rows); });
        f.appendChild(assign);
      }
      var del = el('button', 'fav-footer__btn', T('removeSelected'));
      del.type = 'button';
      del.addEventListener('click', function () {
        var ids = Object.keys(selected).map(Number);
        Promise.all(ids.map(function (id) { return F.api('DELETE', '/items/' + id); }))
          .then(F.load).then(function () { selected = {}; render(); })
          .catch(function (e) { F.toast(e.message || T('failed')); });
      });
      f.appendChild(del);
    }

    var total = el('span', 'fav-footer__total');
    total.dataset.grandTotal = '1';
    f.appendChild(total);

    // ⚠️ Beschriftung MUSS die Auswahl widerspiegeln. Die Einschraenkung auf die
    // ausgewaehlten Positionen gab es schon — nur stand am Knopf weiterhin „In den
    // Warenkorb", sodass niemand erkennen konnte, dass die Auswahl greift.
    var cartBtn = el('button', 'fav-footer__btn fav-footer__btn--primary',
      selCount ? T('addSelectedToCart').replace('{n}', String(selCount)) : T('addAllToCart'));
    cartBtn.type = 'button';
    cartBtn.addEventListener('click', function () { addToCart(rows, cartBtn); });
    f.appendChild(cartBtn);

    var print = el('button', 'fav-footer__btn', T('print'));
    print.type = 'button';
    // Sicherheitsnetz gegen Browser, die afterprint nicht zuverlaessig feuern, steckt
    // in printWhenReady().
    print.addEventListener('click', function () { printWhenReady(rows, print); });
    f.appendChild(print);

    return f;
  }

  /**
   * Mehrere ausgewaehlte Positionen auf MEHRERE Listen verteilen.
   *
   * ⚠️ Ersetzt das fruehere <select> „In Liste verschieben". Das konnte nur EIN Ziel und
   * war ein natives Auswahlfeld — dessen Markierung faerbt der Browser blau, was im
   * Schaltschrank24-Layout wie ein Fremdkoerper wirkte. Beides erledigt sich mit einem
   * Popover aus denselben Kaestchen, die auch am Herzen haengen.
   *
   * Bedeutung der Kaestchen, bezogen auf die AUSGEWAEHLTEN Positionen:
   *   angehakt      → alle liegen in dieser Liste
   *   halb angehakt → ein Teil liegt dort  (indeterminate)
   *   leer          → keine liegt dort
   * Anhaken legt die fehlenden dort ab, Abhaken entfernt die vorhandenen von dort.
   * Verschieben ist damit ausdrueckbar (Ziel anhaken, Quelle abhaken) — und der haeufigere
   * Fall, dasselbe Gehaeuse in zwei Projekten zu fuehren, geht in einem Zug.
   */
  var assignEl = null;

  function closeAssign() {
    if (assignEl) { assignEl.remove(); assignEl = null; }
    document.removeEventListener('click', assignOutside, true);
    document.removeEventListener('keydown', assignEsc, true);
  }
  function assignOutside(e) { if (assignEl && !assignEl.contains(e.target)) closeAssign(); }
  function assignEsc(e) { if (e.key === 'Escape') closeAssign(); }

  /** Die zugrunde liegenden Positionen der ausgewaehlten Zeilen (in „Alle" mehrere je Zeile). */
  function selectedMembers(rows) {
    var out = [];
    rows.forEach(function (r) {
      if (!selected[r.id]) return;
      (r._members || [r]).forEach(function (m) { out.push({ row: r, item: m }); });
    });
    return out;
  }

  function openAssign(anchor, rows) {
    closeAssign();
    if (!F.loggedIn()) { F.toast(T('loginToOrganise')); return; }

    var picked = rows.filter(function (r) { return selected[r.id]; });
    if (!picked.length) return;
    var members = selectedMembers(rows);

    var box = el('div', 'fav-picker');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', T('addToLists'));

    F.ownLists().forEach(function (l) {
      var inList = picked.filter(function (r) {
        return (r._members || [r]).some(function (m) { return m.listId === l.id; });
      });

      var row = el('label', 'fav-picker__row');
      var name = el('span', 'fav-picker__name', l.name);
      var cnt = el('span', 'fav-picker__count', String(l.count || 0));

      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = inList.length === picked.length;
      cb.indeterminate = inList.length > 0 && inList.length < picked.length;

      cb.addEventListener('change', function () {
        cb.disabled = true;
        var jobs;
        if (cb.checked) {
          // Fehlende ergaenzen — vorhandene bleiben unangetastet (addItem ist idempotent).
          jobs = picked
            .filter(function (r) { return !(r._members || [r]).some(function (m) { return m.listId === l.id; }); })
            .map(function (r) {
              return F.api('POST', '/items', {
                listId: l.id, sku: r.sku, handle: r.handle, variantId: r.variantId,
                title: r.title, variantTitle: r.variantTitle, imageUrl: r.imageUrl,
                category: r.category, qty: r.qty
              });
            });
        } else {
          jobs = members
            .filter(function (x) { return x.item.listId === l.id; })
            .map(function (x) { return F.api('DELETE', '/items/' + x.item.id); });
        }
        Promise.all(jobs)
          .then(F.load)
          .then(function () {
            closeAssign();
            render();
            F.toast(cb.checked ? (T('addedTo') + ' ' + l.name) : (T('removed') + ' — ' + l.name));
          })
          .catch(function (e) {
            cb.disabled = false;
            F.toast(e.message || T('failed'));
          });
      });

      row.appendChild(cb); row.appendChild(name); row.appendChild(cnt);
      box.appendChild(row);
    });

    // Neue Liste direkt hier anlegen und die Auswahl hineinlegen.
    var form = el('form', 'fav-picker__new');
    var input = document.createElement('input');
    input.type = 'text'; input.className = 'fav-picker__input';
    input.placeholder = T('newListPlaceholder'); input.maxLength = 120;
    var go = el('button', 'fav-picker__add', '+');
    go.type = 'submit'; go.setAttribute('aria-label', T('newList'));
    form.appendChild(input); form.appendChild(go);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = input.value.trim();
      if (!n) return;
      go.disabled = true;
      F.createList(n)
        .then(function (id) {
          return Promise.all(picked.map(function (r) {
            return F.api('POST', '/items', {
              listId: id, sku: r.sku, handle: r.handle, variantId: r.variantId,
              title: r.title, variantTitle: r.variantTitle, imageUrl: r.imageUrl,
              category: r.category, qty: r.qty
            });
          }));
        })
        .then(F.load)
        .then(function () { closeAssign(); render(); F.toast(T('addedTo') + ' ' + n); })
        .catch(function (err) { go.disabled = false; F.toast(err.message || T('failed')); });
    });
    box.appendChild(form);

    document.body.appendChild(box);
    var r = anchor.getBoundingClientRect();
    box.style.visibility = 'hidden';
    box.style.left = (r.left + window.scrollX) + 'px';
    box.style.top = (r.top + window.scrollY - 8) + 'px';
    assignEl = box;
    requestAnimationFrame(function () {
      // Nach OBEN aufklappen: der Knopf sitzt in der klebenden Fusszeile am Fensterrand.
      var h = box.offsetHeight, w = box.offsetWidth;
      box.style.top = Math.max(window.scrollY + 8, r.top + window.scrollY - h - 8) + 'px';
      var max = document.documentElement.clientWidth - 12;
      if (r.left + w > max) box.style.left = Math.max(12, max - w) + 'px';
      box.style.visibility = '';
    });
    setTimeout(function () {
      document.addEventListener('click', assignOutside, true);
      document.addEventListener('keydown', assignEsc, true);
    }, 0);
    input.focus();
  }

  function refreshFooter() {
    var old = root.querySelector('.fav-footer');
    if (old) { old.replaceWith(buildFooter(itemsOf(view.listId))); paintTotals(); }
  }

  // ── Warenkorb ──────────────────────────────────────────────────────────────

  /**
   * Sammel-Uebernahme in den Warenkorb.
   *
   * ⚠️⚠️ Ein blosses POST auf /cart/add.js REICHT NICHT. Der Warenkorb dieses Themes
   * wird nicht vom Server-Redirect aktualisiert, sondern ueber die Section-Rendering-API:
   * ohne `sections`/`sections_url` im Rumpf und ohne cart.renderContents() bleiben
   * Bubble und Drawer stehen — der Artikel ist zwar im Warenkorb, aber erst nach einem
   * Reload sichtbar.
   *
   * ⚠️⚠️ Und noch wichtiger fuer B2B: assets/b2b-prices.js rechnet die Warenkorbpreise
   * erst um, wenn cart-drawer.js::renderContents laeuft ODER PUB_SUB_EVENTS.cartUpdate
   * veroeffentlicht wird. Wer beides umgeht, sieht im Warenkorb die LISTENPREISE — die
   * Gesamtsumme weicht dann von der Favoritenliste ab, ohne dass irgendwo ein Fehler steht.
   *
   * Vorbild in jedem Detail: assets/variant-matrix.js::post().
   */
  function cartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var c = cartEl();
    return c && c.getSectionsToRender ? c.getSectionsToRender().map(function (x) { return x.id; }) : [];
  }

  /** Echten Serverstand nachladen — noetig, wenn /cart/add.js keine sections liefert. */
  function fetchCartSections() {
    var ids = sectionIds();
    if (!ids.length) return Promise.reject(new Error('no sections'));
    var base = (window.routes && window.routes.cart_url) || window.localizeUrl('/cart');
    return fetch(base + '?sections=' + encodeURIComponent(ids.join(',')), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      if (!r.ok) throw new Error('sections fetch failed');
      return r.json();
    });
  }

  function applyCart(json, sectionsOnly) {
    var c = cartEl();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'favorites-list', cartData: sectionsOnly ? undefined : json });
    }
    if (c && c.renderContents) {
      if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
      c.renderContents(json);
    }
    // Rueckfall, falls das Theme den Preis-Umbau nicht ueber das Ereignis anstoesst.
    if (typeof window.B2BRefreshCart === 'function') {
      setTimeout(window.B2BRefreshCart, 0);
    }
  }

  /**
   * Fusszeile: die AUSGEWAEHLTEN Positionen, sonst alle sichtbaren.
   * Die Beschriftung des Knopfes sagt jeweils, was passiert — siehe buildFooter().
   */
  function addToCart(rows, btn) {
    var chosen = Object.keys(selected).length
      ? rows.filter(function (r) { return selected[r.id]; })
      : rows;
    addRowsToCart(chosen, btn);
  }

  /**
   * Kern: legt genau die uebergebenen Zeilen in den Warenkorb.
   * Wird von der Fusszeile UND vom Warenkorb-Knopf je Zeile benutzt.
   */
  function addRowsToCart(chosen, btn) {
    // In der Zusammenfassung ist r.qty bereits die Summe ueber alle Listen — genau
    // die Menge, die der Kunde insgesamt braucht.

    var items = [], skipped = [], adjusted = [];
    chosen.forEach(function (r) {
      var a = availability[r.handle];
      var v = a && a.bySku && a.bySku[r.sku];
      if (v && v.av === false) { skipped.push(r.title || r.sku); return; }
      var id = (v && v.id) || r.variantId;
      if (!id) { skipped.push(r.title || r.sku); return; }
      // Der Warenkorb kennt nur ganze Stueck. Gebrochene Mengen (Meterware) werden
      // gerundet — und das wird dem Kunden GESAGT, statt es stillschweigend zu tun.
      var q = Math.max(1, Math.round(r.qty));
      if (Math.abs(q - r.qty) > 0.0001) adjusted.push((r.title || r.sku) + ' (' + r.qty + ' → ' + q + ')');
      items.push({ id: id, quantity: q });
    });

    if (!items.length) { F.toast(T('nothingAddable')); return; }

    btn.disabled = true;

    var body = {
      items: items,
      sections: sectionIds(),
      sections_url: window.location.pathname
    };
    var config = (typeof fetchConfig === 'function')
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(body);

    var c = cartEl();
    if (c && c.setActiveElement) c.setActiveElement(document.activeElement);

    fetch(window.localizeUrl('/cart/add.js'), config)
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        btn.disabled = false;

        // Sauberer Erfolg: die angeforderten sections kommen mit.
        if (res.ok && !res.json.status) {
          applyCart(res.json, false);
          report();
          return;
        }

        // ⚠️ Mehrdeutig — vor allem HTTP 422 bei Verfuegbarkeits-Deckelung: Shopify nimmt
        // die gedeckelte Menge TROTZDEM auf, liefert aber keine sections. Der Antwort
        // nicht vertrauen, sondern den echten Warenkorbstand nachladen.
        var info = res.json.description || res.json.message || '';
        return fetchCartSections()
          .then(function (sections) {
            applyCart({ sections: sections }, true);
            report(info);
          })
          .catch(function () {
            F.toast(info || T('failed'));
          });
      })
      .catch(function () { btn.disabled = false; F.toast(T('failed')); });

    function report(extra) {
      var msg = T('addedToCart').replace('{n}', String(items.length));
      if (skipped.length) {
        msg += ' — ' + T('skipped') + ': ' + skipped.slice(0, 3).join(', ') + (skipped.length > 3 ? ' …' : '');
      }
      if (adjusted.length) {
        msg += ' — ' + T('qtyRounded') + ': ' + adjusted.slice(0, 3).join(', ');
      }
      if (extra) msg += ' — ' + extra;
      F.toast(msg);
    }
  }

  // ── Nachtraegliches Fuellen ────────────────────────────────────────────────

  function paintPrices() {
    root.querySelectorAll('.fav-row').forEach(function (tr) {
      var it = itemById(parseInt(tr.dataset.itemId, 10));
      var td = tr.querySelector('[data-price-slot]');
      if (!it || !td) return;
      var p = priceOf(it);
      if (!p) return;                       // Skelett stehen lassen, nie „0.00" zeigen
      td.textContent = '';
      td.appendChild(el('span', 'fav-price-pack', money(p.pack)));
      // Bei Verkaufseinheiten den Preis je Basiseinheit dazuschreiben — dieselbe Angabe
      // wie auf Produktseite und Karte, damit nichts widerspruechlich wirkt.
      if (p.per != null) {
        var lbl = window.unitLabel ? window.unitLabel(p.base || '') : (p.base || '');
        td.appendChild(el('span', 'fav-price-per',
          'CHF ' + window.SU.unitPrice(p.per, parseFloat(itemSuq(it) || 0)) + ' / ' + lbl));
      }
    });
    paintQtyInfo();
    paintTotals();
  }

  function itemById(id) {
    // Register zuerst: es enthaelt genau die Objekte, die in den Zeilen haengen.
    return rendered[id] || F.state.items.filter(function (x) { return x.id === id; })[0] || null;
  }

  function itemSuq(it) {
    var a = availability[it.handle];
    var v = a && a.bySku && a.bySku[it.sku];
    return v ? v.suq : null;
  }

  /**
   * Inhalt je Verkaufseinheit und Gesamtmenge — fuer Meterware UND Stueckware.
   *
   * Beispiele:  „× 12 m  = 24 m"      (2 Bunde à 12 m)
   *             „× 500 Stück  = 1000 Stück"  (2 Beutel à 500 Aderendhuelsen)
   *
   * ⚠️ Nur bei Verkaufseinheiten > 1. Bei suq = 1 ist die Menge selbst schon die
   * Gesamtmenge — eine Zeile „× 1 Stück = 3 Stück" waere blosses Rauschen.
   * ⚠️ Set-Artikel bleiben aussen vor: dort IST die Verkaufseinheit das Set.
   */
  function paintQtyInfo() {
    if (!window.SU) return;
    root.querySelectorAll('[data-qty-info]').forEach(function (n) {
      var it = itemById(parseInt(n.dataset.qtyInfo, 10));
      if (!it) return;
      var a = availability[it.handle];
      var v = a && a.bySku && a.bySku[it.sku];
      n.textContent = '';
      if (!v || v.set) return;
      var q = parseFloat(v.suq || 0) || 0;
      if (!(q > 1)) return;

      var unit = window.SU.qtyUnitLabel(v.sub || '');
      // Ganze Zahlen mit Tausendertrennung („1'000"), gebrochene ohne angehaengte Nullen
      // („2.5" statt „2.500") — window.SU.money fuellt sonst auf die Stellenzahl auf.
      var qTxt = q % 1 ? String(Math.round(q * 1000) / 1000) : window.SU.money(q, 0);
      var per = el('span', 'fav-qty-per', '× ' + qTxt + ' ' + unit);
      n.appendChild(per);

      var tot = window.SU.totalBase(it.qty, q, v.sub || '');
      if (tot) n.appendChild(el('span', 'fav-qty-total', tot.text));
    });
  }

  function paintTotals() {
    // ⚠️ Sobald etwas ausgewaehlt ist, zaehlen NUR die ausgewaehlten Positionen — sonst
    // stuende unter einer Auswahl eine Summe, die zu einer anderen Menge gehoert als der
    // Knopf daneben in den Warenkorb legt. Zeilensummen bleiben je Zeile stehen; nicht
    // gezaehlte Zeilen werden gedaempft, damit der Unterschied sichtbar ist.
    var selCount = Object.keys(selected).length;
    var grand = 0, groupSums = {}, known = true;

    root.querySelectorAll('.fav-row').forEach(function (tr) {
      var id = parseInt(tr.dataset.itemId, 10);
      var it = itemById(id);
      if (!it) return;
      var p = priceOf(it);
      var slot = tr.querySelector('[data-total-slot]');
      var t = p ? lineTotal(p.pack, it.qty) : null;
      if (slot) slot.textContent = t == null ? '' : money(t);

      var counts = !selCount || !!selected[id];
      tr.classList.toggle('is-unselected', selCount > 0 && !counts);
      if (!counts) return;

      if (t == null) { known = false; return; }
      grand += t;
      var g = tr.closest('.fav-table') && tr.closest('.fav-table').dataset.group;
      if (g != null) groupSums[g] = (groupSums[g] || 0) + t;
    });

    root.querySelectorAll('[data-group-sum]').forEach(function (n) {
      var v = groupSums[n.dataset.groupSum];
      n.textContent = v == null ? '' : money(v);
    });
    var gt = root.querySelector('[data-grand-total]');
    if (gt) {
      // Bei unbekannten Preisen ehrlich bleiben: „ab" statt einer Summe, die so tut,
      // als waeren alle Positionen bepreist.
      var label = selCount ? T('totalSelected').replace('{n}', String(selCount)) : T('total');
      gt.textContent = (known ? '' : T('fromPrefix') + ' ') + label + ' ' + money(grand);
      gt.classList.toggle('is-selection', selCount > 0);
    }
  }

  function paintAvailability() {
    root.querySelectorAll('[data-avail-slot]').forEach(function (td) {
      var a = availability[td.dataset.handle];
      if (!a) return;
      var tr = td.closest('.fav-row');
      var sku = tr && tr.dataset.sku;
      td.textContent = '';
      if (a.missing || !a.bySku || !a.bySku[sku]) {
        // ⚠️ Nie stillschweigend verschwinden lassen. Eine Projektliste, aus der
        // Zeilen unbemerkt fallen, ist schlimmer als eine mit Fehlerhinweis.
        td.appendChild(el('span', 'fav-avail fav-avail--gone', T('unavailable')));
        if (tr) {
          tr.classList.add('is-gone');
          var cb = tr.querySelector('.fav-row__cart');
          if (cb) { cb.disabled = true; cb.title = T('unavailable'); }
        }
        return;
      }
      var v = a.bySku[sku];
      td.appendChild(el('span', 'fav-avail ' + (v.av ? 'fav-avail--in' : 'fav-avail--out'),
        v.av ? T('inStock') : T('outOfStock')));
      var cb2 = tr && tr.querySelector('.fav-row__cart');
      if (cb2) { cb2.disabled = !v.av; if (!v.av) cb2.title = T('outOfStock'); }
    });
  }

  function buildEmpty() {
    var box = el('div', 'fav-empty');
    box.appendChild(el('p', 'fav-empty__title', view.query ? T('noMatches') : T('emptyTitle')));
    if (!view.query) {
      box.appendChild(el('p', 'fav-empty__hint', T('emptyHint')));
      var a = document.createElement('a');
      a.className = 'button';
      a.href = window.localizeUrl('/collections/all');
      a.textContent = T('browseProducts');
      box.appendChild(a);
    }
    return box;
  }

  // ── Start ──────────────────────────────────────────────────────────────────

})();
